<template>
	<div class="parent-user-profile">
		<div class="row" align="right" v-if="!isNotTab" style="padding-top: 1rem;">
			<div class="col-md-4">
				<app-breadcrumb :page-title="$t('lead_profile')" />
			</div>
			<div class="col-md-4">
			</div>
			<div class="col-md-4">
				<div class="form-group">
					<app-input
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_lead_id"
						@input="setLeadIdValue"
						:fetch-url="'transaction/lead'"
						placeholder="Student Name"
						list-value-field="full_name"
						label-field="full_name"
					/>
				</div>
			</div>
		</div>
		<div class="row" align="right" v-if="isNotTab" style="padding-top: 1rem;">
			<div class="col-md-4">
				<br>
			</div>
		</div>
		<div class="user-profile mb-primary">
			<div
				class="card position-relative card-with-shadow py-primary border-0"
			>
				<app-overlay-loader v-if="loading" class="h-100" />
				<div v-else class="row align-items-center">
					<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5">
						<div
							class="media border-right px-5 pr-xl-5 pl-xl-0 align-items-center user-header-media"
						>
							<form
								class="mb-0"
								ref="form"
								:data-url="computedUrl"
								:class="{ 'loading-opacity': preloader }"
							>
								<div
									class="profile-pic-wrapper position-relative"
								>
									<app-overlay-loader v-if="preloader" />
									<app-input
										v-else
										id="profile_picture"
										class="circle mx-xl-auto"
										:wrapper-class="'circle mx-xl-auto'"
										name="profile_picture"
										type="custom-file-upload"
										v-model="leadProfileCardData.profile_picture"
										:alt="
											leadProfileCardData.full_name ??
											'Profile Picture'
										"
										:generate-file-url="false"
										@change="setProfilePicture"
										:label="$t('change')"
									/>
									
                                    <app-input v-else
                                               id="profile_picture"
                                               class="circle mx-xl-auto"
                                               :wrapper-class="'circle mx-xl-auto'"
                                               name="profile_picture"
                                               type="custom-file-upload"
                                               v-model="user.profile_picture"
                                               :generate-file-url="false"
                                               @change="setProfilePicture"
                                               :label="$t('change')"/>
								</div>
							</form>
							<div class="media-body user-info-header">
								<h5>{{ leadProfileCardData.full_name }}</h5>
								<p class="text-muted mb-2">
									{{
										leadProfileCardData.chinese_name ??
										"please fill chinese name"
									}}
								</p>
								<p class="text-muted mt-4">
									{{ (leadProfileCardData.parent_interview_status == 1) ? leadProfileCardData.lead_id_number : leadProfileCardData.clc_id_number }}
								</p>
								<!-- <span
									class="badge badge-pill badge-success user-status"
									>{{ sub_status }}</span
								>
								<span
									class="badge badge-pill badge-warning user-status"
									>New</span
								> -->
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
						<div
							class="user-details px-5 px-sm-5 px-md-5 px-lg-0 px-xl-0 mt-5 mt-sm-5 mt-md-0 mt-lg-0 mt-xl-0"
						>
							<div class="row">
								<div
									class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6"
								>
									<div class="border-right custom">
										<div class="media mb-4 mb-xl-5">
											<div class="align-self-center mr-3">
												<app-icon :name="'home'" />
											</div>
											<div class="media-body">
												<p class="text-muted mb-0">
													School Name:
												</p>
												<p class="mb-0">
													{{ leadProfileCardData.school_name }}
												</p>
											</div>
										</div>
										<div class="media mb-4 mb-xl-0">
											<div class="align-self-center mr-3">
												<app-icon :name="'award'" />
											</div>
											<div class="media-body">
												<p class="text-muted mb-0">
													School Level:
												</p>
												<p class="mb-0">
													{{ leadProfileCardData.school_level }}
												</p>
											</div>
										</div>
									</div>
								</div>
								<div
									class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6"
								>
									<div class="media mb-4 mb-xl-5">
										<div class="align-self-center mr-3">
											<app-icon :name="'calendar'" />
										</div>
										<div class="media-body">
											<p class="text-muted mb-0">
												Created Date:
											</p>
											<p class="mb-0">
    											{{ formatDate(leadProfileCardData.created_at) }}
												<!-- <button type="button"
														class="btn btn-warning btn-with-shadow btn-sm" style="background-color: #ffa700 !important; border-color: #ffa700 !important;"
														@click="editCreateDate">
													<i class="fa fa-edit"></i> 
												</button> -->
											</p>
										</div>
									</div>
									<div class="media mb-0 mb-xl-0">
										<div class="align-self-center mr-3">
											<app-icon :name="'gift'" />
										</div>
										<div class="media-body">
											<p class="text-muted mb-0">Age:</p>
											<p class="mb-0">
												{{ leadProfileCardData.age }}
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<create-date-form
            v-if="showModalEditCreateDate"
			form-id="create-date-form" 
            @close-modal="closeCreateDateModal"
            :selectedUrl="`transaction/lead/${leadProfileCardData.id}`"
			@updated="refreshCardData"
            :value="leadProfileCardData"
        />
	</div>
</template>

<script>

import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import { UserMixin } from "../../../../Views/Auth/Mixins/UserMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { urlGenerator } from "../../../../../Helpers/AxiosHelper";
import CreateDateForm from "./CreateDateForm.vue";

export default {
	components: {
		CreateDateForm
	},
	name: "LeadProfileCard",
	mixins: [FormMixin],
	props: {
		leadId: {
			type: String,
		},
		isNotTab: {        
			type: Boolean,
			default: false   
		}
	},
	data() {
		return {
			loading: true,
			preloader: false,
			showModalEditCreateDate :false,
			leadProfileCardData: {
				school_name: "",
				school_level: "",
			},
			sub_status: "",
			user: { profile_picture: "" },
			inputs: {
				lead_id: undefined,
			},
			input_lead_id: {
				id: this.value?.lead?.id || 0,
				full_name: this.value?.lead?.full_name || "",
			},

		};
	},
	mounted: function () {
		this.getData();
		this.fetchData();
	},
	computed: {
		clcIdNumber() {
			// Ekstrak ID dari URL, misalnya: /transaction/profile-lead/2253
			const parts = window.location.pathname.split('/');
			return parts[3] || null; // karena index ke-3 = 2253
		},
		computedUrl() {
			return `/transaction/profile-lead/change-picture/${this.clcIdNumber}`;
		}
	},
	methods: {
		
		refreshCardData() {
			this.fetchData();        
		},
		editCreateDate(){
			this.showModalEditCreateDate = true;
		},
		closeCreateDateModal() {
            let m_id = `#create-date-form`;
            $(m_id).modal('hide');
            this.showModalEditCreateDate = false;
            // this.reSetData();
		},
		async fetchData() {
			try {
				const userResponse = await axios.get(
					"/transaction/lead/" + this.leadId
				);

				this.leadProfileCardData = userResponse.data;
				this.sub_status = userResponse.data.sub_status
					? userResponse.data.sub_status.status
					: "no-status";

				this.leadProfileCardData.school_name = this.leadProfileCardData?.school?.name
				this.leadProfileCardData.school_level = this.leadProfileCardData?.school_level?.name
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		formatDate(dateString) {
			if (!dateString) return "-";
			const tanggal = new Date(dateString);
			return tanggal.toLocaleDateString("en-US", {
				weekday: "short",
				day: "2-digit",
				month: "short",
				year: "numeric",
			});
		},
		beforeSubmit() {
			this.preloader = true;
		},
		getData() {
			// this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		setProfilePicture($event) {
			const fileValue = $event.target.files[0];
			let formData = new FormData();
			formData.append("profile_picture", fileValue);
			this.save(formData);
		},
		afterFinalResponse() {
			this.preloader = false;
		},
		afterSuccess(res) {
			this.$toastr.s(res.data.message);
			this.fetchData();
		},
		setLeadIdValue(data) {
			this.inputs.lead_id = this.inputs.lead_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.lead_id = data.id;
				window.location.href = `/transaction/profile-lead/${data.id}`;
			}
		},
	},
};
</script>
<style scoped>
.card {
	box-shadow: 0 10px 12px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
.user-profile .card {
	min-height: 190px;
}
/* Increase font size and padding to make the badge bigger */
.badge-pill {
	font-size: 15px; /* Adjust the font size as needed */
	padding: 10px 20px; /* Adjust the padding as needed */
}
.parent-user-profile{
	position: sticky;
	top: 0;
	z-index: 999;
	background: #fdfdfd;
}
</style>
